<template>
  <div class="cropp-image-with-drowing">
    <tr-ui-title
      class="freePosition"
      v-if="dataConfig.title"
      :title-text="dataConfig.title.text"
      :audio="dataConfig.title.audio"
      :pos="dataConfig.title.pos"
      style="position: absolute; z-index: 1; width: 94%"
    ></tr-ui-title>
    <div
      class="cropp-image-with-drawing-curtain"
      style="width: 1920px; height: 1080px; background: #f2f2f2; position: fixed; top: -85px; left: -90px; z-index: -10"
    ></div>
    <div style="width: 100%; height: 100%; background: white; position: absolute"></div>
    <div class="inner-box" id="cropp-inner-box" :style="styleForInnerBox()">
      <cropp-image
        v-if="dataConfig.cropp"
        :style="{ transform: 'scale(' + scale + ')' }"
        id="cropped"
        :img-config="dataConfig"
      >
      </cropp-image>
      <button type="close" title="Zamknij ćwiczenie" name="close" @click="handleOk()" class="close-button">
        <svg fill="#ffffff" height="55" viewBox="0 0 24 24" width="55">
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            fill="rgb(230, 230, 230)"
          />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
    </div>
  </div>
</template>
<script>
import CroppImage from './CroppImage';
import TrUiTitle from '__mainSrcDir/components/TrGame/v4/UI/TrUiTitle/TrUiTitle';
export default {
  name: 'cropp-image-with-drowing',
  components: { CroppImage, TrUiTitle },
  data() {
    return {
      scale: 1,
      sampleData: {},
    };
  },
  created() {},
  mounted() {
    this.$store.commit('CHANGE_CANVAS_TOOL_COLOR', '#000000');
    this.$emit('clearCanvas');
    // this.$store.commit('TOGGLE_UI_DISABLE', true);
    // this.$store.commit('TOGGLE_UI_DISABLE', false);
    if (this.dataConfig.scale != false && this.dataConfig.cropp) {
      let tmp = document.getElementById('cropped');
      let tmp2 = document.getElementById('cropp-inner-box');
      this.scale = Math.min.apply(Math, [tmp2.offsetWidth / tmp.offsetWidth, tmp2.offsetHeight / tmp.offsetHeight]);
    }
  },
  destroyed() {
    if (this.$store.getters.realMultibookType) {
      this.$store.commit('CHANGE_MULTIBOOK_TYPE', this.$store.getters.realMultibookType);
      this.$store.commit('CHANGE_REAL_MULTIBOOK_TYPE', null);
    }
    this.$store.commit('TOGGLE_UI_DISABLE', false);
    this.$emit('clearCanvas');
  },
  methods: {
    styleForInnerBox() {
      if (this.dataConfig.title) {
        return { height: 'calc(100% - 140px)', marginTop: '140px' };
      } else {
        return { height: '100%' };
      }
    },
    giveMeImagePlease(path) {
      let multibookMainType = this.$store.getters.multibookType;
      return require(`__staticDir/${multibookMainType}/${path}`);
    },
    handleOk() {
      if (this.$store.getters.realMultibookType) {
        this.$store.commit('CHANGE_MULTIBOOK_TYPE', this.$store.getters.realMultibookType);
        this.$store.commit('CHANGE_REAL_MULTIBOOK_TYPE', null);
      }
      this.$store.commit('CHANGE_MBCIWD_ACTIVE', false);
      this.$store.commit('CHANGE_MBCIWD_CONFIG', {});
      this.$store.commit('CHANGE_MBCIWD_ACTIVE', false);
      this.$store.commit('TOGGLE_CANVAS');
      this.$store.commit('TOGGLE_CANVAS_TOOLBOX');
      this.$store.commit('TOGGLE_CANVAS_TEXT_MARKER', false);
      this.$store.commit('TOGGLE_UI_DISABLE', !this.allTopLayoutDisable);
      this.$emit('clearCanvas');
    },
  },
  computed: {
    dataConfig() {
      return this.$store.getters.mbciwdConfig;
    },
  },
};
</script>
<style lang="sass" scoped>
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
.cropp-image-with-drowing
  width: 100%
  height: 100%
  z-index: 105
  background: white
  position: absolute
  .inner-box
    width: calc(100% - 90px - 90px)
    margin-left: 90px
    background: white
    display: flex
    justify-content: space-evenly
    align-items: center
    flex-direction: column
    .close-button
      pointer-events: auto
      position: absolute
      top: 0
      right: 0
      opacity: 1
      z-index: 1003
      cursor: pointer
      outline: none
      border: none
      background-color: $backgroundControlPanelColor
      margin-right: 12px
      margin-top: 22px
      border-radius: 50%
      display: flex
      transform: scale(1)
      padding: 0
      svg
        path:first-child
          fill: $bacgroundColor
          transition: all 0.4s ease
      &:hover
        svg
          path:first-child
            fill: $closeActiveColor
            transition: all 0.4s ease
        transition: all 0.4s ease
      img
        width: 100%
        height: 100%
</style>
